document.addEventListener("DOMContentLoaded", function () {
    // 倒计时
    function getRandomNum(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    }
  
    let endTimeG;
  
    function cutDownTime() {
      let nowTime = new Date();
      let endTime = new Date(endTimeG);
  
      let leftTime = endTime.getTime() - nowTime.getTime();
      if (leftTime < 0) {
        setupNewCountdown();
        leftTime = 0;
      }
      let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
        leftM = Math.floor((leftTime / (1000 * 60)) % 60),
        leftS = Math.floor((leftTime / 1000) % 60);
      leftH = leftH >= 10 ? leftH : "0" + leftH;
      leftM = leftM >= 10 ? leftM : "0" + leftM;
      leftS = leftS >= 10 ? leftS : "0" + leftS;
  
      return {
        hour: leftH,
        minute: leftM,
        second: leftS,
      };
    }
    function setupNewCountdown() {
      const randomHour = getRandomNum(1, 9);
      const currentTime = new Date();
      endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
    }
    let intervalId;
  
    function getCutDownTime() {
      setupNewCountdown();
      if (intervalId) clearInterval(intervalId);
      intervalId = setInterval(function () {
        let cutDownTimeText = cutDownTime();
        $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
        $(".sp_top_cut_down .sp_left_view .sp_minute").html(
          cutDownTimeText.minute
        );
        $(".sp_top_cut_down .sp_left_view .sp_second").html(
          cutDownTimeText.second
        );
      }, 1000);
    }
  
    getCutDownTime();
  
    new WOW().init();
  
    jQuery(".sp-scroll").slide({
      mainCell: ".nav-imgs",
      autoPlay: true,
      effect: "leftMarquee",
      interTime: 12,
      vis: 1,
      scroll: 1,
    });
  
    new Swiper('.mySwiper', {
      slidesPerView: 'auto',
      spaceBetween: 35,
      loop: true, //循环滚动
      freeMode: true,
      speed: 6500, //匀速时间
      autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: true,
      },
      allowTouchMove: false,
    })
  
    new Swiper(".sp-swiper1", {
      autoplay: true,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
      },
      slideShadows: true,
      slidesPerView: "auto",
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
    });
    new Swiper(".sp-swiper2", {
      autoplay: true,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
      },
      slideShadows: true,
      slidesPerView: "auto",
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
    });
  
    new Swiper(".sp-brands-slider", {
      spaceBetween: 0,
      loop: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      speed: 3000,
      slidesPerView: "auto",
      freeMode: true,
    });
  
    new Swiper(".sp-swiper3", {
      autoplay: true,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
      },
      slideShadows: true,
      slidesPerView: "auto",
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      on: {
        slideChange: function () {
          const activeIndex = this.activeIndex; // 或 this.realIndex
          const bullets = document.querySelectorAll('.sp-pagination1 .swiper-pagination-bullet');
  
          // 先清空所有 swiper-pagination-bullet2
          bullets.forEach(b => b.classList.remove('swiper-pagination-bullet2'));
  
          // 根据当前索引添加类名
          if ([3, 6].includes(activeIndex)) {
            bullets[1]?.classList.add('swiper-pagination-bullet2');
          } else if (activeIndex === 4) {
            bullets[0]?.classList.add('swiper-pagination-bullet2');
          } else if (activeIndex === 5) {
            bullets[1]?.classList.add('swiper-pagination-bullet2');
          }
        }
      }
    });
  
    new Swiper(".sp-swiper-fade", {
      spaceBetween: 10,
      effect: "fade",
      autoplay: true,
      autoplay: {
        disableOnInteraction: false,
        delay: 2000,
      },
      speed: 2000,
    });
  
    new Swiper(".sp-swiper-fade1", {
      autoplay: true,
      autoplay: {
        disableOnInteraction: false,
      },
      spaceBetween: 10,
      loop: true,
      on: {
        slideChange: function (e) {
          e.slides.find(".sp-text").each(function () {
            this.style.animation = "none";
          });
          const spText = e.slides.eq(e.activeIndex).find(".sp-text")[0];
          if (spText) {
            spText.style.animation = "none";
  
            spText.style.animation = `swiper-up-fade 0.5s ease forwards`;
          }
        },
      },
    });
  
    new Swiper(".sp-swiper0", {
      autoplay: true,
      autoplay: {
        disableOnInteraction: false,
      },
      spaceBetween: 10,
      loop: true,
    });
  
    function mainRender() {
      $(function () {
        $("#root").css("zoom", "normal");
        if (document.body.clientWidth <= 1060) {
          let scale = document.body.clientWidth / 1080;
          $("#root").css("zoom", scale);
        } else {
          const scale = document.body.clientWidth / 1920;
          $("#root").css("zoom", scale);
        }
  
        window.addEventListener(
          "resize",
          (function () {
            var timer;
            return function () {
              if (timer) clearTimeout(timer);
              timer = setTimeout(function () {
                $("#root").css("zoom", "normal");
                if (document.body.clientWidth <= 1060) {
                  let scale = document.body.clientWidth / 1080;
                  $("#root").css("zoom", scale);
                } else {
                  const scale = document.body.clientWidth / 1920;
                  $("#root").css("zoom", scale);
                }
              }, 100);
            };
          })()
        );
      });
  
      function lazyLoadImages() {
        // 懒加载
        const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
        const config = {
          rootMargin: "0px 0px 1300px 0px",
          threshold: 0,
        };
  
        const lazyLoadObserver = new IntersectionObserver(function (
          entries,
          observer
        ) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              // 当图片进入视口时
              const image = entry.target;
              const dataSrc = image.getAttribute("data-src");
              if (dataSrc) {
                image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
              }
              lazyLoadObserver.unobserve(image); // 停止观察该图片
            }
          });
        },
          config);
  
        images.forEach(function (image) {
          lazyLoadObserver.observe(image); // 开始观察每个图片
        });
      }
  
      function preloadImages(imageArray) {
        // 预加载
        // 检查数组数据结构
        if (Array.isArray(imageArray[0])) {
          // 处理二维数组
          imageArray.forEach((subArray) => {
            subArray.forEach((url) => {
              const img = new Image();
              img.src = url;
            });
          });
        } else {
          // 处理一维数组
          imageArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        }
      }
  
      lazyLoadImages();
  
      let imgList = [
          "https://cdn.shopify.com/s/files/1/0622/2734/9558/files/20260312-1-2-1.png",
          "https://cdn.shopify.com/s/files/1/0622/2734/9558/files/20260312-1-2-2.png",
          "https://cdn.shopify.com/s/files/1/0694/9427/6234/files/20260312-1-1-3_png.png?v=1778843462",
          "https://cdn.shopify.com/s/files/1/0622/2734/9558/files/20260312-1-1-1.png",
          "https://cdn.shopify.com/s/files/1/0622/2734/9558/files/20260312-1-1-2.png",
          "https://cdn.shopify.com/s/files/1/0694/9427/6234/files/lQLPJwfCL1OcAw3NAU_NAmGwPY7j_Mb7xS0J3G1ZMYyCAQ_609_335.png?v=1778843462",
          "https://cdn.shopify.com/s/files/1/0622/2734/9558/files/20260312-1-3-1.png",
          "https://cdn.shopify.com/s/files/1/0622/2734/9558/files/20260312-1-3-2.png",
          "https://cdn.shopify.com/s/files/1/0694/9427/6234/files/lQLPJwfCL1OcAw3NAU_NAmGwPY7j_Mb7xS0J3G1ZMYyCAQ_609_335.png?v=1778843462",
          "https://cdn.shopify.com/s/files/1/0622/2734/9558/files/20260312-2-2-1.png",
          "https://cdn.shopify.com/s/files/1/0622/2734/9558/files/20260312-2-2-2.png",
          "https://cdn.shopify.com/s/files/1/0694/9427/6234/files/lQLPJx7Jh4-0gm3NARTNAiiwbKMk2p4NpdgJ3HGVyDXnAQ_552_276.png?v=1778843475",
          "https://cdn.shopify.com/s/files/1/0622/2734/9558/files/20260312-2-1-1.png",
          "https://cdn.shopify.com/s/files/1/0622/2734/9558/files/20260312-2-1-2.png",
          "https://cdn.shopify.com/s/files/1/0694/9427/6234/files/lQLPJx82qz0UAm3NAU_NAmSw5T84YKtlJxIJ3HGVyDXnAA_612_335.png?v=1778843475",
          "https://cdn.shopify.com/s/files/1/0622/2734/9558/files/20260312-2-3-1.png",
          "https://cdn.shopify.com/s/files/1/0622/2734/9558/files/20260312-2-3-2.png",
          "https://cdn.shopify.com/s/files/1/0694/9427/6234/files/lQLPJx82qz0UAm3NAU_NAmSw5T84YKtlJxIJ3HGVyDXnAA_612_335.png?v=1778843475"
      ]
      let colorCount = $("#sp-color .sp-option").length || 1;
      let qtyCount = $("#sp-qty .sp-option").length || 1;
      let proCount = $("#sp-pro .sp-option").length || 1;
  
 
      // 预加载所有图片
      // preloadImages(imgList);
  
      // 更新主图显示
        function updateMainImage() {
      // 重新获取当前选中的索引
      let colorIndex = $("#sp-color .sp-option.active").index() ;
      let qtyIndex = $("#sp-qty .sp-option.active").index() 
      let proIndex = $("#sp-pro .sp-option.active").index() 
      const index = colorIndex*9+qtyIndex*3+proIndex
      $(".sp-img-inner div").hide().eq(index).show()
    }
  
      // 数量选项点击事件（sp-color）
      $(".sp-option").click(function () {
        $(this).siblings().removeClass("active");
        $(this).addClass("active");
        updateMainImage();
        changePrice()
      });
  
      // 初始化图片
      updateMainImage();
  
      // IOS字体多了间距的处理
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      var isAndroid = /android/i.test(userAgent);
      var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
      var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent);
  
      if (!isAndroid && !isIOS && !isPC) {
        $(".sp_system").css("letter-spacing", "-4px");
      }
    }
  
    mainRender();
  
    // 找到所有跳转套餐的锚点链接 - 使用事件委托确保所有链接都能工作
    function handleShoppingLinkClick(event) {
      const link = event.target.closest('a[href="#shopping"]');
      if (!link) return;
  
      event.preventDefault();
  
      const targetElement = document.getElementById("shopping");
      if (targetElement) {
        const offsetTop = targetElement.offsetTop;
        let sptop = document.body.clientWidth <= 1080 ? 0 : 110;
        let zoomValue = parseFloat($("div#root").css("zoom")) || 1;
        const scrollTop = offsetTop * zoomValue - sptop * zoomValue;
  
        window.scrollTo({
          top: scrollTop,
          behavior: "smooth",
        });
  
        setTimeout(() => {
          if (window.pageYOffset === 0 || Math.abs(window.pageYOffset - scrollTop) > 100) {
            $('html, body').animate({
              scrollTop: scrollTop
            }, 800);
          }
        }, 100);
      }
    }
  
    // 使用事件委托在document上监听所有点击
    document.addEventListener('click', handleShoppingLinkClick);
  
    let sp_price1 = 9.99;
    let sp_price2 = 19.89;
  
    function calcTotal(price, num) {
      let result = Number(price) * Number(num);
      return result.toFixed(2);
    }
  
    let prods = window.product
      function getCur() {
          let color = $('#sp-color div.active').attr('data-val')
          let qty = $('#sp-qty div.active').attr('data-val')
          // let pro = $('#sp-pro div.active').attr('data-val')
          return prods.filter(
          item =>item.option1 == color && item.option2 == qty)[0]
      }
      function changePrice() {
          let num = $('#calcNumber').val()
          let price = ((getCur().price * num) / 100000).toFixed(3)
          let compare = ((getCur().compare_at_price * num) / 100000).toFixed(3)
          // price = (price + '').replace('.', ',')
          // compare = (compare + '').replace('.', ',')
          $('#sp_price1').html(price)
          $('#sp_price2').html(compare)
          let off_font =
          100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)
          $('.price-group .font-off').html(off_font)
      }
    $('.sp-btn-style').click(function () {
      let num = $('#calcNumber').val()
      let id = getCur().id
      window.location.href = '/cart/' + id + ':' + num
    })
    $(".sp-reduce").click(function () {
      let input = $(this).siblings("input")[0];
      let num = Number(input.value) - 1;
      if (num > 0) {
        input.value = num;
      }
      changePrice()
    });
    $(".sp-add").click(function () {
      let input = $(this).siblings("input")[0];
      let num = Number(input.value) + 1;
      input.value = num;
      changePrice()
    });
  
    // 标题文本渐出
    const graduallyList = document.getElementsByClassName("gradually");
    for (let gradually of graduallyList) {
      const spans = gradually.querySelectorAll("span, div");
      const paragraph = gradually.querySelector(".sp-sub-title");
  
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // 给每个 span/div 和 i 动画
              spans.forEach((span, index) => {
                span.style.animation = `swift-up-fade 0.5s ease forwards`;
                span.style.animationDelay = `${index * 0.1}s`;
  
                const i = span.querySelector("i");
                if (i) {
                  i.style.animation = `swift-up-fade 0.5s ease forwards`;
                  i.style.animationDelay = `${index * 0.1}s`;
                }
              });
  
              // 段落
              const totalDelay = spans.length * 0.1 + 0.3;
              if (paragraph) {
                paragraph.style.animation = `swift-up-fade2 0.5s ease forwards`;
                paragraph.style.animationDelay = `${totalDelay}s`;
              }
  
              observer.unobserve(gradually);
            }
          });
        },
        {
          threshold: 0.3,
        }
      );
      observer.observe(gradually);
    }
  
    // 菜单
    $(".sp-menu-btn").click(function (e) {
      $(".sp-menu-mask").show();
    });
  
    $(".sp-menu-mask").click(function (e) {
      $(".sp-menu-mask").hide();
    });
  
    function getZoomValue() {
      let zoom = $("div#root").css("zoom");
      return parseFloat(zoom) || 1;
    }
  
    function handleScroll() {
      // let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      // let zoomValue = getZoomValue();
      // let headerHeight = $(".header:visible").height() * zoomValue;
  
      // if (scrollTop > headerHeight) {
      //   $(".sp-pc .sp-header-top").addClass("sp-fixed");
      // } else {
      //   $(".sp-pc .sp-header-top").removeClass("sp-fixed");
      // }
    }
  
    // 初始检查
    handleScroll();
  
    // 监听多种滚动事件
    window.addEventListener('scroll', handleScroll, true);
    document.addEventListener('scroll', handleScroll, true);
  
    $(function () {
      // 判断是否为移动端
      function isMobile() {
        return document.body.clientWidth <= 1060;
      }
  
      // 购物车加购动效
      $(".cart-btn").click(function () {
        $(this).children("img").addClass("on");
        if (isMobile()) {
          $(".sp-mobile .sp-cart .num").show();
          $(".sp-mobile .sp-cart").addClass("on");
          setTimeout(function () {
            $(".sp-mobile .sp-cart").removeClass("on");
          }, 500);
        } else {
          $(".sp-pc .sp-header-top .sp-cart .num").show();
          $(".sp-pc .sp-header-top .sp-cart").addClass("on");
          setTimeout(function () {
            $(".sp-pc .sp-header-top .sp-cart").removeClass("on");
          }, 500);
        }
        setTimeout(function () {
          $(".cart-btn").children("img").removeClass("on");
        }, 500);
      });
  
      let initNum = 0;
  
      $(".product-part .cart-btn").click(function () {
        const data = {
            id: getCur().id,
            quantity: $('#calcNumber').val(),
        }
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            success: function () {
                $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
                $('.cardNum').html(result.item_count)
                $('.cardNum').removeClass('sp-gray')
                })
            },
            dataType: 'json',
        })
  
        var imgs = $(".sp-img-inner .active");
  
        imgs.each(function () {
          var $img = $(this);
          var flyer = $img[0].cloneNode(true);
          flyer.classList.add("sp_clone");
  
          $(".product-part").append(flyer);
          $(flyer).css({
            width: $img[0].width,
            height: $img[0].height,
            background: "#e7e9ef",
            position: "fixed",
            top: $img[0].offsetTop,
            left: $img.offset().left,
            "z-index": 99,
          });
  
          let finish, targetTop, targetLeft;
  
          if (isMobile()) {
            // 移动端：飞向底部固定按钮中的购物车
            finish = $(".sp-btn-style2.sp-mobile .sp-cart");
            if (finish.length > 0) {
              targetTop = $(".sp-btn-style2")[0].offsetTop;
              targetLeft = $(".sp-btn-style2 .sp-cart")[0].offsetLeft + finish.width() / 2 + 20;
            } else {
              targetTop = 0;
              targetLeft = 0;
            }
          } else {
            // PC端：飞向header中的购物车
            finish = $(".sp-pc .sp-cart");
            if (finish.length > 0) {
              targetTop = finish[0].offsetTop;
              targetLeft = finish[0].offsetLeft;
            } else {
              targetTop = 0;
              targetLeft = 0;
            }
          }
  
          $(flyer).animate(
            {
              top: targetTop,
              left: targetLeft,
              width: 50,
              height: 50,
              opacity: 0.4,
            },
            500,
            "linear",
            function () {
              $(this).animate(
                {
                  width: 0,
                  height: 0,
                  opacity: 0,
                },
                0,
                function () {
                  $(this).detach();
                }
              );
            }
          );
        });
      });
    });
  
    // 问答
    $(".q-row").click(function () {
      $(this).parent().toggleClass("sp-show");
    });
  
    // 文本渐出动画
    const graduallyList2 = document.getElementsByClassName("sp-fade-box");
    for (let gradually2 of graduallyList2) {
      const paragraph2 = gradually2.querySelectorAll(".sp-ani");
  
      const observerAni = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              paragraph2.forEach((span, index) => {
                span.style.animation = `sp-fade-in 1s ease forwards`;
                span.style.animationDelay = `${index * 0.5 + 0.5}s`;
              });
  
              observerAni.unobserve(gradually2);
            }
          });
        },
        {
          threshold: 0.3,
        }
      );
      observerAni.observe(gradually2);
    }
    // 文本渐出动画
    const graduallyList3 = document.getElementsByClassName("sp-fade-box2");
    for (let gradually3 of graduallyList3) {
      const paragraph3 = gradually3.querySelectorAll(".sp-ani2");
  
      const observerAni = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              paragraph3.forEach((span, index) => {
                span.style.animation = `sp-fade-left 1s ease forwards`;
                span.style.animationDelay = `${index * 0.3 + 1}s`;
              });
  
              observerAni.unobserve(gradually3);
            }
          });
        },
        {
          threshold: 0.3,
        }
      );
      observerAni.observe(gradually3);
    }
  });
  